import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { VisitorsNumbersByTermGraph } from "../../../../components/Graphs/graphs";
import {
    SelectUTMTermStatus,
  SelectVisitors,
  SelectPercentBooking,
  SelectPercentBought,
  SelectWeeks,
  SelectLabels,
  graphUTMTerm,

} from "./utmTermSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";

const UTMTerm = ({ display }) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];

//   const UTMTermData = useSelector((state) => state.utmTerm);
  const loading = useSelector(SelectUTMTermStatus);
  const weeks = useSelector(SelectWeeks);
  const visitors = useSelector(SelectVisitors);
  const percentBooking = useSelector(SelectPercentBooking);
  const percentBought = useSelector(SelectPercentBought);
  const adsLabels = useSelector(SelectLabels);

  useEffect(() => {
    if (!user) return null;
    if(weeks.length===0) dispatch(graphUTMTerm(user));
  }, [user, weeks]);

  if (loading === "loading") return <SingleGraphLoading />;
  return (
    <VisitorsNumbersByTermGraph
      loading={loading === "loading"}
      display={display}
      weeks={weeks}
      visitors={visitors}
      percentOfBooking={percentBooking}
      nameLabels={adsLabels}
      totalSales={percentBought}
    />
  );
};

export default UTMTerm;